export default "__VITE_ASSET__DCaAsu3q__"